// Chrome Translate y algunas extensiones reemplazan los textos de la página por <font>.
// Cuando React después quiere mover o sacar ese texto, el nodo ya no está donde lo dejó y
// la app entera se cae con "insertBefore/removeChild: el nodo no es hijo de este nodo".
// Con esto esa operación puntual se ignora en vez de romper la pantalla
// (workaround conocido: https://github.com/facebook/react/issues/11538).
if (typeof Node === 'function' && Node.prototype && !Node.prototype.__lisualDomGuard) {
  const removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) console.warn('removeChild: el nodo ya no es hijo de este padre (¿traductor del navegador?)');
      return child;
    }
    return removeChild.apply(this, arguments);
  };
  const insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) console.warn('insertBefore: el nodo de referencia ya no es hijo de este padre (¿traductor del navegador?)');
      return newNode;
    }
    return insertBefore.apply(this, arguments);
  };
  Node.prototype.__lisualDomGuard = true;
}
